import React, { useState } from "react";
import { formateDateToReadableFormatWithoutTime, formateDateToTime } from "../../../utiles/dateformate";
import { TIME_SHEET_STATUS, TIME_SHEET_TIME_AMMEND_STATUS } from "../../../constants";
import { getTimeSheetPdfApiService } from "../../../services/applicationBackendApis/timesheets";
import CircularLoader from "../../../Components/Icons/circularLoader";
import Icon from "../../../Components/Icons";
import { StatusDot } from "../../../Components/DataTable";

export const timesheetActionRequired = (timesheet) => {
  if (timesheet?.timeAmmendmentRequested) {
    return timesheet?.timeAmmendmentRequest?.status == TIME_SHEET_TIME_AMMEND_STATUS.PENDING;
  }
  return false;
};

function TimesheetDownload({ timesheet }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadTimehseetPdf = async () => {
    try {
      setIsDownloading(true);

      const response = await getTimeSheetPdfApiService({
        timesheetId: timesheet.id,
      });

      const timesheetPdf = response.data.base64File;

      // Download profile base 64 as pdf file
      const linkSource = `data:application/pdf;base64,${timesheetPdf}`;
      const downloadLink = document.createElement("a");
      const fileName = `Timesheet_${timesheet.refId}.pdf`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    } catch (error) {
      console.log(error);
    }

    setIsDownloading(false);
  };

  if (isDownloading) return <CircularLoader $size={20} />;
  return (
    <button
      type="button"
      aria-label="Download"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        downloadTimehseetPdf();
      }}
      onKeyDown={(e) => e.stopPropagation()}
      style={{ background: "none", border: 0, padding: 4, cursor: "pointer", display: "inline-flex" }}
    >
      <Icon $icon="Download" $size="large" $color="primary" />
    </button>
  );
}

const nameCell = (row, text) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 600 }}>
    {timesheetActionRequired(row) && <Icon $icon="Warning" $size="large" $color="orange" />}
    {text}
  </span>
);

// Columns for the timesheet list. Same fields and labels as before.
export const timesheetColumns = ({ clientId, staffId }) => {
  const nameColumns =
    !staffId && !clientId
      ? [
          { key: "staff", header: "Staff", width: "17%", primary: true, render: (row) => nameCell(row, row?.staff?.name) },
          { key: "client", header: "Client", width: "17%", render: (row) => <strong>{row?.client?.name}</strong> },
        ]
      : [
          {
            key: "name",
            header: "Name",
            width: "34%",
            primary: true,
            render: (row) => nameCell(row, clientId ? row?.staff?.name : row?.client?.name),
          },
        ];

  return [
    ...nameColumns,
    { key: "date", header: "Date", width: "15%", align: "center", render: (row) => formateDateToReadableFormatWithoutTime(row.startDate) },
    { key: "start", header: "Start time", width: "10%", align: "center", render: (row) => formateDateToTime(row.startDate) },
    { key: "end", header: "End time", width: "10%", align: "center", render: (row) => formateDateToTime(row.endDate) },
    { key: "break", header: "Break", width: "10%", align: "center", render: (row) => `${row.breakDuration} mins` },
    {
      key: "status",
      header: "Status",
      width: "10%",
      align: "center",
      render: (row) => {
        const accepted = row.timesheetStatus === TIME_SHEET_STATUS.ACCEPTED;
        return <StatusDot color={accepted ? "green" : "orange"} label={accepted ? "Accepted" : "Pending"} />;
      },
    },
    {
      key: "actions",
      header: "Actions",
      width: "9%",
      align: "center",
      render: (row) => <TimesheetDownload timesheet={row} />,
    },
  ];
};
